var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-body"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("content")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }